import { auth } from "./FirebaseService";
import { signInAnonymously, onAuthStateChanged } from "firebase/auth";

/**
 * Sign in anonymously
 */
async function anonymousSignIn() {
  try {
    const userCredential = await signInAnonymously(auth);
    return userCredential.user;
  } catch (err) {
    console.error('Anonymous sign in error:', err);
    throw err;
  }
}

/**
 * Get current user from Firebase auth
 */
function getCurrentUser() {
  return auth.currentUser || null;
}

/**
 * Get current UID
 */
function getUid() {
  return auth.currentUser?.uid || null;
}

/**
 * Check if user is authenticated
 */
function isAuthenticated() {
  return !!auth.currentUser;
}

/**
 * Listen to auth state changes
 * @param {Function} callback - Function called when auth state changes
 * @param {Function} errorCallback - Function called on error
 * @returns {Function} Unsubscribe function
 */
function onAuthStateChange(callback, errorCallback) {
  return onAuthStateChanged(auth, callback, errorCallback);
}

export {
  anonymousSignIn,
  getCurrentUser,
  getUid,
  isAuthenticated,
  onAuthStateChange
};
